import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
import { bthomeObjectInfos } from './virtual_bthome_helper';
import { capFirstChar } from '../utilities';
import { getStatusIconByRole } from '../xt1_helpers/template_helpers';
import { getWebIcon } from './virtual_components_settings_helpers';
//Types
import type {
	VirtualComponentConfig,
	VirtualComponentUI,
	VirtualIcon,
	VirtualWebIcons,
} from 'src/types/VirtualComponents';

export const getWebIconStatuses = (): VirtualWebIcons[] => {
	const $format = get(format);
	return [
		{
			value: 0,
			icon: '',
			title: $format('option_none', { default: 'None' }),
		},
		{
			value: 1,
			icon: 'fas fa-toggle-on',
			icon_on: 'fas fa-toggle-on',
			icon_off: 'fas fa-toggle-off',
			label_on: $format('on', { default: 'on' }),
			label_off: $format('off', { default: 'off' }),
			title: $format('icon_name_basic', { default: 'Basic' }),
		},
		{
			value: 2,
			icon: 'fas fa-door-open',
			icon_on: 'fas fa-door-open',
			icon_off: 'fas fa-door-closed',
			label_on: $format('state_opened', { default: 'opened' }),
			label_off: $format('state_closed', { default: 'closed' }),
			title: $format('icon_name_door', { default: 'Door' }),
			bthome_obj: ['door', 'window'],
		},
		{
			value: 3,
			icon: 'fak fa-light-empty-garage',
			icon_on: 'fak fa-light-empty-garage',
			icon_off: 'fas fa-garage',
			label_on: $format('state_opened', { default: 'opened' }),
			label_off: $format('state_closed', { default: 'closed' }),
			title: $format('icon_name_garage', { default: 'Garage' }),
			bthome_obj: ['garage_door'],
		},
		{
			value: 4,
			icon: 'fas fa-bell',
			icon_on: 'fas fa-bell-on',
			icon_off: 'fas fa-bell-slash',
			label_on: $format('state_chiming', { default: 'chiming' }),
			label_off: $format('state_silent', { default: 'silent' }),
			title: $format('icon_name_bell', { default: 'Bell' }),
		},
		{
			value: 5,
			icon: 'far fa-thermometer-three-quarters',
			title: $format('collapse_title_chart_temperature', {
				default: 'Temperature',
			}),
			bthome_obj: ['temperature', 'cold'],
		},
		{
			value: 6,
			icon: 'far fa-humidity',
			title: $format('collapse_title_chart_humidity', { default: 'Humidity' }),
			bthome_obj: ['humidity', 'water'],
		},
		{
			value: 7,
			icon: 'fas fa-circle-bolt',
			title: $format('label_voltage', { default: 'Voltage' }),
			bthome_obj: ['voltage'],
		},
		{
			value: 8,
			icon: 'fas fa-battery',
			title: $format('icon_name_battery', { default: 'Battery' }),
			bthome_obj: ['battery'],
		},
		{
			value: 9,
			icon: 'fas fa-location-dot',
			title: $format('label_location', { default: 'Location' }),
		},
		{
			value: 10,
			icon: 'fa-light fa-gauge-high',
			title: $format('icon_name_pressure', { default: 'Pressure' }),
			bthome_obj: ['pressure'],
		},
		{
			value: 11,
			icon: 'fab fa-cloudversify',
			title: $format('icon_name_gas', { default: 'Gas' }),
			bthome_obj: ['pm2.5', 'pm10', 'gas', 'tvoc', 'co2', 'carbon_monoxide'],
		},
		{
			value: 12,
			icon: 'far fa-mountain',
			title: $format('icon_name_altitude', { default: 'Altitude' }),
			bthome_obj: ['distance_m'],
		},
		{
			value: 13,
			icon: 'far fa-clock',
			title: $format('icon_name_time', { default: 'Time' }),
			bthome_obj: ['duration', 'timestamp'],
		},
		{
			value: 14,
			icon: 'fas fa-sun',
			icon_on: 'fas fa-sun',
			icon_off: 'fas fa-moon',
			label_on: $format('option_motion_mode_bright', { default: 'Bright' }),
			label_off: $format('option_motion_mode_dark', { default: 'Dark' }),
			title: $format('icon_name_illuminance', { default: 'Illuminance' }),
			bthome_obj: ['illuminance', 'light'],
		},
		{
			value: 15,
			icon: 'far fa-gauge-circle-plus',
			title: $format('icon_name_count', { default: 'Count' }),
			bthome_obj: ['count'],
		},
		{
			value: 16,
			icon: 'fas fa-person-walking',
			icon_on: 'fas fa-person-walking',
			icon_off: 'fas fa-person',
			label_on: $format('motion', { default: 'motion' }),
			label_off: $format('status_no', { default: 'no' }),
			title: $format('icon_name_motion', { default: 'Motion' }),
			bthome_obj: ['motion', 'moving', 'running'],
		},
		{
			value: 17,
			icon: 'fas fa-angle',
			title: $format('icon_name_rotation', { default: 'Rotation' }),
			bthome_obj: ['rotation'],
		},
		{
			value: 18,
			icon: 'far fa-hand-back-point-up',
			title: $format('icon_name_button', { default: 'Button' }),
			bthome_obj: ['button'],
		},
		{
			value: 19,
			icon: 'fas fa-blinds-raised',
			icon_on: 'fas fa-blinds-raised',
			icon_off: 'fas fa-blinds',
			label_on: $format('state_opened', { default: 'opened' }),
			label_off: $format('state_closed', { default: 'closed' }),
			title: $format('icon_name_blinds', { default: 'Blinds' }),
			bthome_obj: [],
		},
		{
			value: 20,
			icon: 'fas fa-droplet',
			icon_on: 'fas fa-droplet',
			icon_off: 'far fa-droplet',
			label_on: $format('on', { default: 'on' }),
			label_off: $format('off', { default: 'off' }),
			title: $format('icon_name_irrigation', { default: 'Irrigation' }),
			bthome_obj: [],
		},
		{
			value: 21,
			icon: 'fas fa-pipe-valve',
			icon_on: 'fas fa-pipe-valve',
			icon_off: 'far fa-pipe-valve',
			label_on: $format('state_opened', { default: 'opened' }),
			label_off: $format('state_closed', { default: 'closed' }),
			title: $format('icon_name_valve', { default: 'Valve' }),
			bthome_obj: [],
		},
		{
			value: 22,
			icon: 'fas fa-bolt',
			title: $format('power', { default: 'Power' }),
			bthome_obj: ['energy', 'power', 'current'],
		},
		{
			value: 23,
			icon: 'fas fa-raindrops',
			title: $format('opt_chance_rainfall', { default: 'Rainfall' }),
			bthome_obj: ['precipitation'],
		},
		{
			value: 24,
			icon: 'fas fa-droplet-percent',
			title: $format('icon_name_moisture', { default: 'Moisture' }),
			bthome_obj: ['moisture'],
		},
		{
			value: 25,
			icon: 'far fa-droplet-degree',
			title: $format('label_dewpoint', { default: 'Dewpoint' }),
			bthome_obj: ['dewpoint'],
		},
		{
			value: 26,
			icon: 'fas fa-sun-bright',
			title: $format('title_uv_index_card', { default: 'UV index' }),
			bthome_obj: ['uv_index', 'uv'],
		},
		{
			value: 27,
			icon: 'fas fa-wind',
			title: $format('opt_wind_speed', { default: 'Wind speed' }),
			bthome_obj: ['speed', 'wind_speed'],
		},
		{
			value: 28,
			icon: 'fas fa-wind',
			title: capFirstChar(
				$format('option_scene_weather_cond_wind_direction', {
					default: 'Wind direction',
				}),
			),
			bthome_obj: ['direction'],
		},
	];
};

export const getVirtualIconStatus = (
	value: any,
	type: string,
	config: VirtualComponentConfig,
): VirtualIcon => {
	const configUI: VirtualComponentUI = config?.['ui'] || config?.meta?.ui || {};
	if (configUI.webIcon || /^(bthomesensor|bthomedevice)$/.test(type)) {
		const webIconStatuses: VirtualWebIcons[] = getWebIconStatuses();
		let vcIcon: VirtualWebIcons;
		let iconColor = null;
		if (type == 'bthomedevice') {
			const view = configUI.view;
			if (view == 'battery') {
				vcIcon = webIconStatuses[8];
			} else if (view == 'rssi') {
				vcIcon = webIconStatuses[9];
			} else {
				vcIcon = webIconStatuses[13];
			}
		} else if (type == 'bthomesensor') {
			const bthomeObj = bthomeObjectInfos.find((i) => i.id == config?.obj_id);
			vcIcon = webIconStatuses.find((i) => i.bthome_obj && i.bthome_obj.includes(bthomeObj?.name));
		} else {
			vcIcon = webIconStatuses[configUI.webIcon];
		}
		if (
			(type == 'boolean' || (type == 'bthomesensor' && typeof value === 'boolean')) &&
			vcIcon?.icon_on
		) {
			return {
				icon: value ? vcIcon.icon_on : vcIcon.icon_off,
				label: value ? vcIcon.label_on : vcIcon.label_off,
				title: vcIcon.title,
			};
		}
		if (vcIcon?.value == 8 && value !== null) {
			//battery
			const batteryIcon = getBatteryIconStatus(value);
			vcIcon.icon = batteryIcon.icon;
			iconColor = batteryIcon.iconColor;
			if (batteryIcon.iconStyle) {
				return {
					icon: vcIcon.icon,
					color: iconColor,
					iconStyle: batteryIcon.iconStyle,
					title: vcIcon.title,
				};
			}
		}
		return vcIcon?.icon ? { icon: vcIcon.icon, color: iconColor, title: vcIcon.title } : null;
	}
	if (type == 'boolean' && value !== null) {
		return { icon: `fas fa-toggle-${value ? 'on' : 'off'}` };
	}
	return null;
};

export const getBatteryIconStatus = (
	value: number,
): {
	icon: string;
	iconColor?: string;
	iconStyle?: string;
} => {
	const webIconStatuses: VirtualWebIcons[] = getWebIconStatuses();
	let icon = webIconStatuses[8].icon;
	let iconColor: string = null;
	let iconStyle: string = null;

	if (value <= 5) {
		icon = 'fas fa-battery-empty';
		iconColor = '--color-danger';
	} else if (value <= 15) {
		icon = 'fas fa-battery-low';
		iconColor = '--color-warning';
	} else if (value <= 25) {
		icon = 'fa-duotone fa-light fa-battery-quarter';
		iconStyle = '--fa-secondary-color: var(--color-3); --fa-secondary-opacity: 1;';
	} else if (value <= 50) {
		icon = 'fa-duotone fa-light fa-battery-half';
		iconStyle = '--fa-secondary-color: var(--color-3); --fa-secondary-opacity: 1;';
	} else if (value <= 75) {
		icon = 'fa-duotone fa-light fa-battery-three-quarters';
		iconStyle = '--fa-secondary-color: var(--color-3); --fa-secondary-opacity: 1;';
	} else {
		icon = 'fa-duotone fa-light fa-battery-full';
		iconStyle = '--fa-secondary-color: var(--color-3); --fa-secondary-opacity: 1;';
	}

	return { icon, iconColor, iconStyle };
};

export const getVirtualIcon = (vcSettings: VirtualComponentConfig): string => {
	if (vcSettings?.role) {
		return getStatusIconByRole(vcSettings?.role);
	}
	if (vcSettings?.obj_id) {
		const webIconStatuses: VirtualWebIcons[] = getWebIconStatuses();
		const icon = webIconStatuses.find(
			(i) => i.bthome_obj && i.bthome_obj.includes(vcSettings.name),
		)?.icon;
		if (icon) return icon;
	}
	const iconId = Number(vcSettings?.meta?.ui?.webIcon);
	return getWebIcon(iconId)?.icon || '';
};
